import { useMenuState } from '@szhsin/react-menu';

import { getVolumeHistory } from 'actions/user';
import { downloadData } from 'helpers/utils';
import { useAppDispatch } from 'storeHooks';
import DownloadArrow from 'styles/assets/icons/DownloadArrow';
import FilterDropdown from 'UIKit/FilterDropDown';

import styles from './downloadVolumeData.module.scss';
import cn from 'classnames';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';

const DownloadVolumeData = () => {
  const [menuState, toggleMenu] = useMenuState();
  const dispatch = useAppDispatch();
  const fileName = new Date().toUTCString();

  const downloadVolumeOptions = ['24h', '7d'].map((time, idx) => {
    return {
      label: time,
      id: idx,
      onClick: () => {
        return dispatch(getVolumeHistory(time)).then(downloadData(fileName, 'text/csv'));
      },
    };
  });

  const btnClassName = cn({
    [styles.downloadSmall]: IS_INDIAN_EXCHANGE,
  });

  const labelProps = IS_INDIAN_EXCHANGE
    ? {
        label: 'Download',
      }
    : {
        labelIcon: <DownloadArrow className={styles.downloadIcon} />,
      };

  return (
    <FilterDropdown
      menuState={menuState}
      toggleMenu={toggleMenu}
      options={downloadVolumeOptions}
      closeOnSelect
      styleOverrideClasses={{ labelSection: styles.labelSection }}
      btnClassName={btnClassName}
      testId="download-btn"
      {...labelProps}
    />
  );
};

export default DownloadVolumeData;
